import { isDailyDateFormat } from "./chartDataSampling";

/** Normalize API chart bucket strings to `YYYY-MM-DD` or `YYYY-MM`. */
export function chartBucketKeyFromPointDate(raw: string): string {
  const s = String(raw).trim();
  if (s.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(s)) {
    return s.slice(0, 10);
  }
  if (s.length >= 7 && /^\d{4}-\d{2}/.test(s)) {
    return s.slice(0, 7);
  }
  return s;
}

/**
 * Keep only series points whose bucket falls inside the dashboard picker's inclusive
 * local calendar window (same YMD strings as `local_start_date` / `local_end_date`).
 */
export function filterChartPointsToLocalRange<T extends { date: string }>(
  points: T[],
  localStart: string | null | undefined,
  localEnd: string | null | undefined
): T[] {
  if (!points.length || !localStart || !localEnd) {
    return points;
  }
  const start = localStart.slice(0, 10);
  const end = localEnd.slice(0, 10);
  const sampleKey = chartBucketKeyFromPointDate(points[0]?.date ?? "");
  const daily = isDailyDateFormat(sampleKey);

  if (daily) {
    return points.filter((point) => {
      const ymd = chartBucketKeyFromPointDate(point.date);
      return ymd >= start && ymd <= end;
    });
  }

  const startYm = start.slice(0, 7);
  const endYm = end.slice(0, 7);
  return points.filter((point) => {
    const ym = chartBucketKeyFromPointDate(point.date);
    return ym >= startYm && ym <= endYm;
  });
}
